module.exports = __webpack_public_path__ + "static/media/Professional Surfer.d50b9e20.jpg";